/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.directives {
    export interface IGisWherePredicateCollectionScope extends angular.IScope {
        save:any;
        addPredicate:any;
        removePredicate:any;
        placeHolderChanged:any;
        esriMapServiceLayer:any;
        wherePredicates:any;
        gisDatastore:Wars.Domain.Model.Gis.GisDatastore;
        gisDatastoreQueryConfiguration:Wars.Domain.Model.Gis.GisDatastoreQueryConfiguration;
        esriQueryConfiguration:Wars.Domain.Model.Gis.EsriQueryConfiguration;
        currentGisDatastoreAttributes:any;
        mapConfiguration:Wars.Domain.Model.Gis.MapConfiguration;
    }

    export class GisWherePredicationCollection implements IDirective{
        public link($scope: IDrawStyleScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/gisWherePredicateCollection.html";
        public restrict: string = "E";
        public controller = ["$scope",'mapConfigurationService',GisWherePredicationCollectionController];
        public controllerAs = "controller";
        public scope: any = {
            wherePredicates:"=",
            esriMapServiceLayer:"=",
            gisDatastore:"=",
            gisDatastoreQueryConfiguration:"=",
            esriQueryConfiguration:"=",
            mapConfiguration:"="
        };
    }

    export class GisWherePredicationCollectionController {
        constructor(private $scope: IGisWherePredicateCollectionScope, private mapConfigurationService: services.MapConfigurationService) {
            $scope.save = () => this.save();
            $scope.addPredicate = () => this.addPredicate();
            $scope.removePredicate = (a) => this.removePredicate(a);
            $scope.placeHolderChanged = (a) => this.placeHolderChanged(a);

            if (this.$scope.gisDatastore) {
                this.setupGisDatastoreAttributes();
            }
        }

        public addPredicate() {
            let newPredicate = this.mapConfigurationService.createGisWherePedicate();

            newPredicate.compareOperator = Wars.Domain.Model.Codes.Enums.CompareOperator.Equals;

            if (this.$scope.esriMapServiceLayer) {
                newPredicate.field = this.$scope.esriMapServiceLayer.fields[0];
            }
            if (this.$scope.gisDatastore) {
                this.setupGisDatastoreAttributes();
            }

            newPredicate.isPlaceholder = false;
            newPredicate.placeHolderUniqueIdentifier = services.UtilityService.generateGuidComb();
            newPredicate.javascriptTransformer_id = null;

            this.$scope.wherePredicates.push(newPredicate);
            console.log(this.$scope);

            this.save();
        }

        private setupGisDatastoreAttributes() {
            this.$scope.currentGisDatastoreAttributes = [];
            if (this.$scope.gisDatastore) {
                for (let i = 1; i < 21; i++) {
                    if (this.$scope.gisDatastore['metadata' + i + 'PropertyName']) {
                        this.$scope.currentGisDatastoreAttributes.push({
                            name: this.$scope.gisDatastore['metadata' + i + 'PropertyName'],
                            index: i
                        });
                    }
                }
            }
        }

        public placeHolderChanged(predicate: Wars.Domain.Model.Gis.GisWherePredicate) {
            if (predicate.isPlaceholder) {
                predicate.value= "";
            } else {
                predicate.placeholderName = "";
            }

            this.save();
        }

        public removePredicate(predicate: Wars.Domain.Model.Gis.GisWherePredicate) {
            predicate.entityAspect.setDeleted();
            this.save();
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }
    }

}

warsApp.registerDirective('GisWherePredicationCollection',[]);